import {useEffect} from 'react';

const usePixel = (pixelKey, pixelId) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://vk.com/js/api/openapi.js?' + pixelId;

        script.onload = () => {
            window.VK.Retargeting.Init(pixelKey);
            window.VK.Retargeting.Hit();
        };

        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        }
    }, [pixelKey, pixelId]);
};

export default usePixel;